import { Model } from 'app/model/backendmodel';
import { AdapterRegistry, SalesforceServiceCloudDataset } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SalesforceServiceCloudDataset),
    disabled: __IS_FABRIC_DPE__,
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            folder: '*',
            annotations: '*',
            schema: '*',
            linkedServiceName: '*',
            parameters: '*',
            type: '*',
            typeProperties: {
                objectApiName: '*'
            }
        }
    }
})
export class SalesforceServiceCloudDatasetAdapter extends TabularTypeDatasetAdapter<SalesforceServiceCloudDataset, Model.DatasetResource> {
    protected async _toResource(dataset: SalesforceServiceCloudDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(SalesforceServiceCloudDataset).name, 'objectApiName');
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: SalesforceServiceCloudDataset): Promise<SalesforceServiceCloudDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, SalesforceServiceCloudDataset.MODEL, 'objectApiName');
    }
}
